export default __webpack_public_path__ + "static/deliveryStep02-1add7c0c7a7fdbea2539d6bb82a97e3a.svg";